export default {"src":"/_next/static/media/buy.80023020.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};